{
  "name": "bpp-stella-web",
  "version": "1.3.0-SNAPSHOT",
  "private": true,
  "description": "Web frontend go stella for g&o Brokernet",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4700 --configuration local",
    "build": "ng build",
    "build:development": "ng build --configuration development",
    "build:staging": "ng build --configuration staging",
    "build:main": "ng build --configuration production",
    "watch": "ng build --watch --configuration local",
    "test": "jest",
    "test:watch": "jest --watch",
    "lint": "ng lint"
  },
  "dependencies": {
    "@angular/animations": "21.2.22",
    "@angular/common": "21.2.22",
    "@angular/compiler": "21.2.22",
    "@angular/core": "21.2.22",
    "@angular/forms": "21.2.22",
    "@angular/platform-browser": "21.2.22",
    "@angular/router": "21.2.22",
    "@jsverse/transloco": "^8.4.0",
    "@microsoft/signalr": "^10.0.0",
    "@primeicons/angular": "^8.0.1",
    "@primeuix/themes": "^2.0.2",
    "firebase": "12.8.0",
    "pdf-lib": "^1.17.1",
    "pdfjs-dist": "^4.10.38",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.9",
    "rxjs": "7.8.1",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "21.4.0",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/build": "21.2.22",
    "@angular/cli": "21.2.22",
    "@angular/compiler-cli": "21.2.22",
    "@angular/language-service": "21.2.22",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.30.0",
    "@tailwindcss/postcss": "^4.1.17",
    "@types/jest": "^30.0.0",
    "@typescript-eslint/eslint-plugin": "^8.68.0",
    "@typescript-eslint/parser": "^8.68.0",
    "eslint": "^9.30.0",
    "globals": "^16.2.0",
    "jest": "^30.0.0",
    "jest-environment-jsdom": "^30.0.0",
    "jest-preset-angular": "^17.0.0",
    "jsdom": "^26.0.0",
    "postcss": "^8.5.26",
    "tailwindcss": "^4.1.12",
    "typescript": "5.9.3",
    "typescript-eslint": "8.68.0"
  }
}
